import React, { FC, memo, useState } from 'react'
import { StartMainProps } from './types/StartMainProps'
import { css } from 'emotion'
import flippers from './turtle-flippers.gif'
import agree from './agree.gif'
import chair from './chair.gif'
import bump from './bump.gif'
import sadLips from './sad-lips.gif'
import rock from './rock.gif'
import fried from './fried.gif'
import dance from './dance.gif'
import handsome from './handsome.gif'
import dogTongue from './dog-tongue.gif'
import chips from './chips.gif'
import bonk from './bonk.gif'
import crown from './crown.gif'
import carrot from './carrot.gif'
import snowboard from './snowboard.gif'
import blackbird from './blackbird.gif'
import snorkeling from './snorkeling.gif'
import cuddle from './cuddle.gif'
import idk from './idk.gif'
import rubFace from './rub-face.gif'
import stretching from './stretching.gif'
import wimper from './wimper.gif'
import coupleCuddle from './couple-cuddle.gif'
import piggyDressUp from './piggy-dress-up.gif'
import sushiCheers from './sushi-cheers.gif'
import chaiseCat from './chaise-cat.gif'
import puppyYawning from './puppy-yawning.gif'
import catScratch from './cat-scratch.gif'
import dogDangle from './dog-dangle.gif'
import tada from './tada.gif'
import nonono from './nonono.webp'
import lalala from './lalala.gif'
import catdice from './catdice.webp'
import chipmunk from './chipmunk.webp'
import canary from './canary.webp'
import areyouok from './areyouok.gif'
import wow from './wow.webp'
import kisses from './kisses.webp'
import bugs from './bugs.gif'
import bigcat from './bigcat.webp'
import fingers from './fingers.gif'
import hug from './hug.gif'
import pocketme from './pocketme.gif'
import liar from './liar.gif'
import smoothbrain from './smoothbrain.gif'
import dontSmell from './dont-smell.gif'
import dimSum from './dim-sum.gif'
import buttPatt from './butt-patt.gif'
import lucky from './lucky.gif'
import chin from './chin.gif'
import { appStyles } from 'styles/appStyles'

const items2021 = [
  {
    description: 'I love when you do Flippers and become an Outlaw!',
    img: flippers,
  },
  { description: 'I love when you agree and face snuggle me.', img: agree },
  {
    description: 'I love when you do chair and fit perfectly in my legs.',
    img: chair,
  },
  { description: 'I love when you do the sad lip bump.', img: sadLips },
  { description: 'I love when you ask me to give you a bump.', img: bump },
  { description: 'I love steeling rocks with you.', img: rock },
  {
    description: 'I love the way you eat fried chicken and see you so happy.',
    img: fried,
  },
  {
    description: 'I love the shower dance ritual we do before getting out.',
    img: dance,
  },
  {
    description:
      'I love the way to like to try new things like flying, snowboarding and skating.',
    img: snowboard,
  },
  { description: 'I love going to national parks with you.', img: snorkeling },
]

const items2022 = [
  {
    description: 'I love when you call me handsome man.',
    img: handsome,
  },
  { description: 'I love when you go Crown!', img: crown },
  { description: 'I love to carrot with you.', img: carrot },
  {
    description:
      'I love when you put your leg over mine in bed (during winter)',
    img: coupleCuddle,
  },
  {
    description: 'I love to snuggle on the sofa with you.',
    img: cuddle,
  },
  {
    description: 'I love it when you say I dont know.',
    img: idk,
  },
  {
    description: 'I love it when you whimper like a puppy.',
    img: wimper,
  },
  {
    description: 'I love it when you rub your face against mind while purring.',
    img: rubFace,
  },
  {
    description: 'I love it when you fix my clothes.',
    img: piggyDressUp,
  },
  {
    description: 'I love it when you Nigiri me!',
    img: stretching,
  },
]

const items2023 = [
  {
    description: 'I love when you fall asleep with your mouth opened.',
    img: dogTongue,
  },
  { description: 'I love it when we go Bonk!', img: bonk },
  {
    description: 'I love when you sing songs on our road trip.',
    img: blackbird,
  },
  {
    description: 'I love when you go crunchi crunchi.',
    img: chips,
  },
  {
    description: 'I love it when we bink before eating.',
    img: sushiCheers,
  },
  {
    description: 'I love it when we chaise time.',
    img: chaiseCat,
  },
  {
    description: 'I love it when you go ngah.',
    img: puppyYawning,
  },
  {
    description: 'I love it when you scratch my tummy.',
    img: catScratch,
  },
  {
    description: 'I love it when you dangle your feet.',
    img: dogDangle,
  },
  {
    description: 'I love it when you go TA DA!',
    img: tada,
  },
]

const items2024 = [
  {
    description: 'I love the way you say no no no.',
    img: nonono,
  },
  { description: 'I love it when you say canary.', img: canary },
  {
    description: 'I love it when you say wow.',
    img: wow,
  },
  {
    description: 'I love it when you ask "are you ok??"',
    img: areyouok,
  },
  {
    description: 'I love it when you ask for kisses.',
    img: kisses,
  },
  {
    description: 'I love rescuing you from bugs.',
    img: bugs,
  },
  {
    description: 'I love how you like super small or big things.',
    img: bigcat,
  },
  {
    description: 'I love it when you point with your fingers.',
    img: fingers,
  },
  {
    description: 'I love it when you hug your friends.',
    img: hug,
  },
  {
    description: 'I love it when you show me pointless things.',
    img: smoothbrain,
  },
]

const items2025 = [
  {
    description:
      'I love the way you sing la la la la with two half yard in Las Vegas.',
    img: lalala,
  },
  {
    description: 'I love the way you Chipmunk when I feed you.',
    img: chipmunk,
  },
  {
    description: 'I love it when I pocket you',
    img: pocketme,
  },
  {
    description: 'I love the way you say liar!',
    img: liar,
  },
  {
    description: 'I love the way you say Dont Smell!',
    img: dontSmell,
  },
  {
    description: 'I love to eat AYCE Dim Sum at Hakasan with you.',
    img: dimSum,
  },
  {
    description: 'I love the way you play the butt patting song.',
    img: buttPatt,
  },
  {
    description: 'I love the way you say Lucky!',
    img: lucky,
  },
  {
    description: 'I love the way you scratch my chin.',
    img: chin,
  },
  {
    description:
      'I love the way you won 4 numbers in a roll in craps at Park MGM',
    img: catdice,
  },
]

const itemGroups = [
  { title: '10 things I love about you in 2021', items: items2021 },
  { title: '10 things I love about you in 2022', items: items2022 },
  { title: '10 things I love about you in 2023', items: items2023 },
  { title: '10 things I love about you in 2024', items: items2024 },
  { title: '10 things I love about you in 2025', items: items2025 },
]

export const StartMain: FC<StartMainProps> = memo(({ styles = '' }) => {
  const [showNumber, setShowNumber] = useState<number | null>()
  const [showGroup, setShowGroup] = useState<number | null>()
  return (
    <div
      className={
        'StartMain ' +
        css`
          min-height: 100vh;
          padding: ${appStyles().spacing.bigger};
          ${styles}
        `
      }
    >
      {itemGroups.map(({ title, items }, i) => {
        return (
          <>
            <h1
              style={{ marginTop: '32px' }}
              onClick={() => {
                setShowGroup(showGroup === i ? null : i)
                setShowNumber(null)
              }}
              className={
                showGroup === i
                  ? css`
                      font-size: ${appStyles().fontSizes.biggest};
                      color: ${appStyles().textColor.danger.medium};
                    `
                  : ''
              }
            >
              {title}
            </h1>
            {showGroup === i && (
              <ol>
                {items.map(({ description, img }, i) => {
                  return (
                    <li
                      key={i}
                      className={css`
                        margin-top: 16px;
                      `}
                    >
                      {showNumber === i && (
                        <>
                          <span
                            className={css`
                              color: ${appStyles().textColor.danger.medium};
                              animation: color-change 1s ease-in-out infinite
                                alternate;
                            `}
                          >
                            {description}
                          </span>
                          <img
                            className={css`
                              margin-top: 8px;
                              max-width: 100%;
                              display: block;
                            `}
                            alt="description"
                            src={img}
                          />
                        </>
                      )}
                      {showNumber !== i && (
                        <button
                          className={css`
                            padding: 16px 32px;
                            font-size: 24px;
                            background-color: orange;

                            &:hover {
                              animation: background-color-change 3s infinite;
                            }
                          `}
                          onClick={() => {
                            setShowNumber(i)
                          }}
                          type="button"
                        >
                          {i + 1}
                        </button>
                      )}
                    </li>
                  )
                })}
              </ol>
            )}
          </>
        )
      })}
    </div>
  )
})
